{
  "schema_version": 1,
  "task_id": "L5-USER-DECISION-PACKS-READINESS-001",
  "status": "decision-packs-readiness-ready",
  "generated_at": "2026-07-31T08:05:00+08:00",
  "source_decision_center": "config/l5-user-decision-center.json",
  "source_activation_pack": "config/l5-user-decision-activation-pack.json",
  "source_templates": "config/l5-user-decision-task-spec-templates.json",
  "source_safety_harness": "config/l5-external-action-safety-harness.json",
  "source_entry_point": "user-decision-packs-readiness",
  "title_zh": "用户决策包体检",
  "title_en": "User decision pack readiness audit",
  "body_zh": "AIOS 已把真实云同步、生态发布和生产级外部分发整理成三张可审核决策包：每张都能说明还缺哪些用户选择、第一步安全动作是什么、何时必须停止，以及为什么现在不能执行。这里仍然只读，不保存选择、不收集密钥、不触发外部动作。",
  "body_en": "AIOS has turned real cloud sync, ecosystem publishing and production external distribution into three reviewable decision packs: each shows missing user choices, the first safe action, stop conditions and why it cannot execute now. This remains read-only: no decision storage, no secret collection and no external effects.",
  "authority_boundary": {
    "observational_only": true,
    "readiness_audit_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "embeds_secret_values": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "external_message": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "tool_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "decision_pack_count": 3,
    "ready_for_user_review_count": 3,
    "task_spec_preparation_ready_count": 3,
    "requires_user_decision_count": 3,
    "required_user_input_count": 18,
    "missing_user_input_count": 18,
    "stop_condition_count": 15,
    "can_start_now_count": 0,
    "can_execute_now_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "stores_user_decision_count": 0,
    "visible_capability": "user-decision-activation-pack-readonly",
    "adds_new_visible_capability": false,
    "remaining_user_decision_count": 3
  },
  "readiness_cards": [
    {
      "id": "READY-REAL-CLOUD-SYNC",
      "source_decision_id": "L5-REAL-CLOUD-SYNC-USER-DECISION-001",
      "source_pack_id": "ACTIVATE-REAL-CLOUD-SYNC",
      "source_template_id": "TEMPLATE-REAL-CLOUD-SYNC",
      "category": "cloud-sync",
      "title_zh": "真实云同步决策包",
      "title_en": "Real cloud-sync decision pack",
      "state": "waiting-for-user-choice",
      "ready_for_user_review": true,
      "task_spec_preparation_ready": true,
      "can_start_now": false,
      "can_execute_now": false,
      "missing_user_inputs": [
        "provider",
        "account_owner",
        "oauth_secret_path",
        "cost_budget",
        "data_scope",
        "conflict_policy",
        "rollback_owner"
      ],
      "first_safe_step_zh": "用户填写服务商、账号责任、Secret 注入路径、费用停止线、数据范围、冲突策略与回滚验收后，Codex 只能先生成激活 Task Spec。",
      "first_safe_step_en": "After the user fills provider, account owner, Secret injection path, cost stop line, data scope, conflict policy and rollback acceptance, Codex may only draft the activation Task Spec first.",
      "why_not_now_zh": "缺少账号/费用/数据范围/回滚边界；现在启动会越过用户控制权并可能产生云写入或费用。",
      "why_not_now_en": "Account, cost, data scope and rollback boundaries are missing; starting now would bypass user control and could create cloud writes or cost.",
      "stop_conditions": [
        "missing_secret_path",
        "unknown_cost_boundary",
        "no_rollback_owner",
        "failed_read_only_preflight",
        "reviewer_fail"
      ],
      "no_go_actions": [
        "connect_account",
        "start_oauth",
        "store_secret",
        "cloud_read",
        "cloud_write",
        "paid_action"
      ]
    },
    {
      "id": "READY-ECOSYSTEM-PUBLISHING",
      "source_decision_id": "L5-ECOSYSTEM-PUBLISHING-ACTIVATION-USER-DECISION-001",
      "source_pack_id": "ACTIVATE-ECOSYSTEM-PUBLISHING",
      "source_template_id": "TEMPLATE-ECOSYSTEM-PUBLISHING",
      "category": "ecosystem-publishing",
      "title_zh": "生态发布决策包",
      "title_en": "Ecosystem publishing decision pack",
      "state": "waiting-for-user-choice",
      "ready_for_user_review": true,
      "task_spec_preparation_ready": true,
      "can_start_now": false,
      "can_execute_now": false,
      "missing_user_inputs": [
        "publication_target",
        "license_attribution",
        "publishing_account",
        "cost_policy",
        "unpublish_path",
        "support_boundary"
      ],
      "first_safe_step_zh": "用户填写发布目标、许可署名、账号、费用配额、撤回路径与支持边界后，Codex 只能先生成发布激活 Task Spec。",
      "first_safe_step_en": "After the user fills target, license/attribution, account, cost/quota, unpublish path and support boundary, Codex may only draft the publishing activation Task Spec first.",
      "why_not_now_zh": "缺少许可、账号、费用、撤回与支持责任；现在发布会越过法律/归属/成本边界。",
      "why_not_now_en": "License, account, cost, unpublish and support responsibilities are missing; publishing now would bypass legal, attribution and cost boundaries.",
      "stop_conditions": [
        "missing_license_choice",
        "unknown_publishing_account",
        "unknown_cost_boundary",
        "missing_unpublish_path",
        "reviewer_fail"
      ],
      "no_go_actions": [
        "publish_plugin",
        "publish_skill",
        "submit_marketplace",
        "external_distribution",
        "external_write",
        "paid_action"
      ]
    },
    {
      "id": "READY-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "source_decision_id": "L5-EXTERNAL-DISTRIBUTION-USER-DECISION-001",
      "source_pack_id": "ACTIVATE-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "source_template_id": "TEMPLATE-PRODUCTION-EXTERNAL-DISTRIBUTION",
      "category": "external-distribution",
      "title_zh": "生产级外部分发决策包",
      "title_en": "Production external-distribution decision pack",
      "state": "waiting-for-user-choice",
      "ready_for_user_review": true,
      "task_spec_preparation_ready": true,
      "can_start_now": false,
      "can_execute_now": false,
      "missing_user_inputs": [
        "legal_account",
        "distribution_policy",
        "cost_support",
        "rollback_incident_plan",
        "external_communication"
      ],
      "first_safe_step_zh": "用户填写法律主体、分发策略、费用与支持责任、回滚事故预案和对外沟通边界后，Codex 只能先生成分发激活 Task Spec。",
      "first_safe_step_en": "After the user fills legal entity, distribution policy, cost/support responsibility, rollback/incident plan and external-communication boundary, Codex may only draft the distribution activation Task Spec first.",
      "why_not_now_zh": "缺少法律主体、费用支持、事故预案与对外沟通边界；现在分发会把责任外溢给用户。",
      "why_not_now_en": "Legal entity, cost/support, incident plan and external-communication boundaries are missing; distributing now would externalize responsibility to the user.",
      "stop_conditions": [
        "missing_legal_account_choice",
        "unknown_cost_boundary",
        "missing_support_owner",
        "missing_rollback_incident_plan",
        "reviewer_fail"
      ],
      "no_go_actions": [
        "production_distribution",
        "deployment",
        "external_write",
        "external_message",
        "store_secret",
        "paid_action"
      ]
    }
  ],
  "decision_ladder": [
    {
      "step": 1,
      "label_zh": "用户补齐选择",
      "label_en": "User fills choices",
      "allowed_effect": "chat_or_documented_choice_only"
    },
    {
      "step": 2,
      "label_zh": "Codex 生成正式 Task Spec",
      "label_en": "Codex drafts formal Task Spec",
      "allowed_effect": "local_task_spec_only"
    },
    {
      "step": 3,
      "label_zh": "只读预检与回滚演练",
      "label_en": "Read-only preflight and rollback drill",
      "allowed_effect": "local_readonly_evidence_only"
    },
    {
      "step": 4,
      "label_zh": "独立 Reviewer 通过后等待显式 go",
      "label_en": "Wait for explicit go after independent Reviewer PASS",
      "allowed_effect": "no_external_effect_until_user_go"
    }
  ],
  "guardrails": [
    "readiness_audit_only",
    "no_user_choice_storage",
    "no_secret_collection",
    "no_external_write",
    "no_cloud_sync",
    "no_publish",
    "no_distribution",
    "no_paid_action",
    "no_runtime_activation",
    "explicit_user_go_required"
  ],
  "quality_gates": [
    "source_decision_center_consistency",
    "source_activation_pack_consistency",
    "source_template_consistency",
    "source_safety_harness_consistency",
    "desktop_official_site_readonly_surface",
    "no_executable_ui",
    "evidence_reviewer_receipt"
  ]
}
